/**
 * Sprint V100 (17.09.2026) — LP-QuickTest-Abschnitt.
 *
 * Vorher: v4-Multiple-Choice-Fragen mit Magic-Link-Flow.
 * Jetzt: Wrapper um QuickCheckV100 (Likert-Skala + Kontext-Differenzierung).
 *
 * `onMagicLink` wird beibehalten fuer API-Kompatibilitaet mit LandingPage.jsx,
 * aber nicht mehr genutzt. Der V100-Flow endet mit einem Link auf den
 * 20-Fragen-Test statt einem Magic-Link-Modal.
 *
 * V99 A/B-Test-Anschluss ist in QuickCheckV100 integriert (mit Version-Marker
 * `version: "v100_likert"` in CAPI-Events).
 *
 * Sprint V102.ab (02.10.2026) — Fragenset-A/B v1 vs. v2.
 *   useQuestionSet() entscheidet pro Besucher (Cookie 30 Tage sticky,
 *   Override via ?questions=v1|v2). v1 => QuickCheckV100 (Status quo),
 *   v2 => QuickCheckV102 (Antreiber-Fokus, Direktstart ohne Kontext-Switcher).
 */
import React from "react";
import QuickCheckV100 from "@/components/quickcheck/QuickCheckV100";
import QuickCheckV102 from "@/components/quickcheck/QuickCheckV102";
import useQuestionSet from "@/hooks/useQuestionSet";

export function QuickTestSection({ onMagicLink }) {
  const questionSet = useQuestionSet();
  const isV2 = questionSet === "v2";
  return (
    <section
      id="quicktest"
      className="relative py-16 sm:py-24 bg-white dark:bg-slate-950"
      data-testid="quicktest-section"
      data-question-set={questionSet}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] sm:text-xs font-bold uppercase tracking-widest text-[#F3651D]">
            QuickCheck &middot; 5 Fragen &middot; 2 Minuten
          </p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 dark:text-white leading-[1.1]">
            Erkenne dein Muster.<br />
            Verstehe deine Wirkung.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Fünf Situationen, eine ehrliche Selbsteinschätzung. Danach weißt du,
            welcher Fokustyp dich prägt.
          </p>
        </div>

        {isV2 ? (
          <QuickCheckV102
            source="landing_page_quicktest"
            onMagicLink={onMagicLink}
          />
        ) : (
          <QuickCheckV100
            source="landing_page_quicktest"
            onMagicLink={onMagicLink}
          />
        )}
      </div>
    </section>
  );
}

export default QuickTestSection;
